import React from "react";

import LogsFilter from "~/pages/Logs/components/LogsFilter";

import { ivideonLogsFilterFields } from "./fields";

const IvideonLogsFilter = () => <LogsFilter fields={ivideonLogsFilterFields} />;

export default IvideonLogsFilter;
